// extracted by mini-css-extract-plugin
export default {"ForsideInnleieSide":"ForsideInnleieSide-module__ForsideInnleieSide__y44gZ","Grid":"ForsideInnleieSide-module__Grid__TZvZK","GridItem":"ForsideInnleieSide-module__GridItem__gnE8X"};